/* eslint-disable max-len */
import React from 'react';

export const CloudMoon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6675_1282)">
        <path
          d="M9.62496 7.58299C11.1281 7.58299 12.3898 6.54929 12.738 5.15399C12.4884 5.21631 12.2272 5.24939 11.9583 5.24939C10.1864 5.24939 8.74996 3.81297 8.74996 2.04105C8.74996 1.77228 8.78301 1.51122 8.84527 1.26172C7.45015 1.61003 6.41663 2.87165 6.41663 4.37465C6.41663 4.90707 6.54632 5.4092 6.77583 5.85117M2.91663 4.08297V1.74963M1.74996 2.9163H4.08329M3.49996 12.833C2.21129 12.833 1.16663 11.7883 1.16663 10.4996C1.16663 9.34588 2.00401 8.38771 3.10416 8.19973C3.57507 6.82291 4.88024 5.83297 6.41663 5.83297C7.75141 5.83297 8.91168 6.58015 9.50199 7.67908C9.72672 7.61645 9.96359 7.58297 10.2083 7.58297C11.658 7.58297 12.8333 8.75822 12.8333 10.208C12.8333 11.6577 11.658 12.833 10.2083 12.833C7.97218 12.833 5.73607 12.833 3.49996 12.833Z"
          stroke="#101828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6675_1282">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
